import { Injectable } from '@angular/core';
import {
  HttpRequestPayload,
  IHttpErrorPayload,
  IHttpSuccessPayload,
} from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { RateService } from 'src/app/services/rate/rate.service';

@Injectable()
export class ExchangeRateService {
  constructor(private _httpProvider: HttpProviderService, private _common:CommonService

    ) {}

  public getExchangeRate(currencyCode: string): Observable<any> {
    const requestPayload: HttpRequestPayload = {
      method: 'GET',
      resource: `/fxrates/${this._common.baseCurrency}/${currencyCode}`,
    };
    return this._httpProvider.invokeApi(requestPayload).pipe(
      map((res: IHttpSuccessPayload<any>) => {
        if(res && res.body && res.body.fxrates) return res.body.fxrates;
        else return null;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
